<template>
  <!DOCTYPE html>
  <html lang="es">
  <head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">

    <!-- Agregar el enlace al archivo de la biblioteca FontAwesome -->
    <link href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.3/css/all.min.css" rel="stylesheet">
    <link type="text/css" rel="stylesheet" href="https://unpkg.com/bootstrap/dist/css/bootstrap.min.css" />
    <link type="text/css" rel="stylesheet" href="https://unpkg.com/bootstrap-vue@latest/dist/bootstrap-vue.min.css" />

    <!-- Load polyfills to support older browsers -->
    
  </head>
  <body :class="{'background-login': login, 'bg-gray-100': !login}">
    <div class="container-fluid d-flex flex-row p-0 m-0">
      <!-- Barra lateral en el lado izquierdo -->
      <aside class="bg-orange text-white" :class="{'small': small, 'p-3': !small, 'p-1': small}" v-if="!login">
        <div>
          <img id="fb-logo-client" src="./assets/icon/bot.png" @click="toggleSmall()">
          <span class="text-white ms-2 mt-3 pb-5 font-roboto-bold-20-white" v-if="!small">Herramientas</span>
        </div>

        <div class="card">
          <div class="card-body">
            <ul class="list-group list-group-light">
              <li title="Teléfono" class="list-group-item px-2 border-0 " :class="{'active': $route.path.includes('/searchfleet'), '' : !$route.path.includes('/searchfleet')}">
                <router-link to="/searchfleet" :class="{ 'font-roboto-regular-15': !$route.path.includes('/searchfleet'), 'font-roboto-regular-15-white': $route.path.includes('/searchfleet') }" exact>
                  <span class="icon">📱</span><span v-if="!small">Teléfono</span>
                </router-link>
              </li>
              <li title="Nueva Flota" class="list-group-item px-2 border-0" :class="{'active': $route.path.includes('/newfleet'), '' : !$route.path.includes('/newfleet')}">
                <router-link to="/newfleet" :class="{ 'font-roboto-regular-15': !$route.path.includes('/newfleet'), 'font-roboto-regular-15-white': $route.path.includes('/newfleet') }" exact>
                  <span class="icon">📗</span><span v-if="!small">Nueva Flota</span>
                </router-link>
              </li>
              <li title="Sistema" class="list-group-item px-2 border-0" :class="{'active': $route.path.includes('/system'), '' : !$route.path.includes('/system')}">
                <router-link to="/system" :class="{ 'font-roboto-regular-15': !$route.path.includes('/system'), 'font-roboto-regular-15-white': $route.path.includes('/system') }" exact>
                  <span class="icon">📊</span><span v-if="!small">Sistema</span>
                </router-link>
              </li>
            </ul>
          </div>
        </div>
      </aside>

      <!-- Contenido principal (router) en el lado derecho -->
      <div class="container-fluid">
        <router-view></router-view>
      </div>
    </div>
  </body>
  </html>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      small: false,
      login: false, // Cambiado a isLogin
    };
  },
  watch: {
    $route() {
      this.checkLoginStatus();
    },
  },
  mounted() {
    let user = localStorage.getItem('user');
    let pass = localStorage.getItem('pass');

    this.small = localStorage.getItem('small') === 'true';

    if (user && pass) {
        if (!this.loginChecked) {
            this.checkLoginStatus();
            this.loginChecked = true;

            if (this.$route.path === '/login') {
                if (this.login) {
                    this.$router.push('/');
                }
            }
        }
    } else {
        this.$router.push('/login');
    }
  },
  methods: {
    toggleSmall() {
      this.small = !this.small;
      localStorage.setItem('small', this.small);
    },
    checkLoginStatus() {
      this.login = this.$route.path === '/login';
    },
  },
};
</script>

<style scoped>
  .icon {
    font-size: 1.5rem;
    padding-right: 0.5rem;
  }

  a {
    text-decoration: none;
  }

  .card {
    text-align: left !important;
  }

 .bg-orange {
    padding-top: 1rem !important;
    background-color: #FFA500;
    min-width: 14rem;
    min-height: 54.2rem;
  }

  .bg-orange > div {
    text-align: center;
    margin-bottom: 3rem;
  }

  .bg-orange > div.small {
    color:green;
  }

  .bg-orange > div > img {
    width: 3rem;
    height: 3rem;
    cursor: pointer;
  }

  .bg-orange.small {
    min-width: 5rem;
  }

  .active {
    border-radius: inherit;
  }

  .list-group-item {
    padding-top: 15px !important;
    padding-bottom: 15px !important;
  }

  #app {
    font-family: Avenir;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
  }
</style>
